export const useScrollIds = defineStore("useScrollIds", () => {
    // * cookie
    const pricing_section = ref<string>("pricing_section");

    return { pricing_section };
});
